const map = {
	"./alert-2.svg": 14722,
	"./alert.svg": 74153,
	"./analytics-fill.svg": 66243,
	"./analytics.svg": 68383,
	"./apple.svg": 31667,
	"./arrow-down.svg": 55041,
	"./arrow-next.svg": 46752,
	"./arrow-prev.svg": 61728,
	"./arrow-right.svg": 38633,
	"./arrow-top.svg": 72452,
	"./arrow-up.svg": 44008,
	"./arrow.svg": 60510,
	"./bag.svg": 62305,
	"./bar_chart.svg": 46217,
	"./bell.svg": 10508,
	"./book.svg": 24540,
	"./bookmark.svg": 95481,
	"./calendar.svg": 58579,
	"./card-like.svg": 31549,
	"./card-mark.svg": 64459,
	"./card-play.svg": 45948,
	"./card-repeat.svg": 34473,
	"./card-share.svg": 17293,
	"./checkbox-circle.svg": 27835,
	"./checkbox.svg": 8268,
	"./checked-circle.svg": 28069,
	"./checked.svg": 82542,
	"./clock.svg": 86765,
	"./close.svg": 39495,
	"./close2.svg": 8663,
	"./collection.svg": 83569,
	"./collections.svg": 65486,
	"./comment.svg": 91574,
	"./comments.svg": 22299,
	"./copy-link.svg": 61667,
	"./copy.svg": 55864,
	"./countdown-left.svg": 52710,
	"./countdown.svg": 29332,
	"./delete-fill.svg": 18396,
	"./delete.svg": 9986,
	"./deselect.svg": 44242,
	"./disabled.svg": 28997,
	"./double-arrow.svg": 95392,
	"./download.svg": 41705,
	"./earning-fill.svg": 16365,
	"./email.svg": 37963,
	"./eye-hidden.svg": 72489,
	"./eye.svg": 79138,
	"./facebook.svg": 54369,
	"./filter.svg": 73307,
	"./flag-color.svg": 20961,
	"./flag.svg": 94507,
	"./go-out.svg": 39438,
	"./google-color.svg": 70040,
	"./google-g-no-circle.svg": 39537,
	"./hamburger.svg": 6508,
	"./heart.svg": 9847,
	"./home-fill.svg": 87256,
	"./home.svg": 33798,
	"./image.svg": 722,
	"./instagram.svg": 99423,
	"./less.svg": 77436,
	"./lightning.svg": 87125,
	"./line.svg": 6043,
	"./lock.svg": 57066,
	"./logo-a.svg": 64576,
	"./logo-text.svg": 2454,
	"./logo.svg": 99378,
	"./logout.svg": 23455,
	"./menu-arrow.svg": 29614,
	"./menu.svg": 86498,
	"./move.svg": 56776,
	"./not-connect.svg": 29113,
	"./organize.svg": 51632,
	"./package-fill.svg": 85187,
	"./package.svg": 67551,
	"./palette.svg": 62020,
	"./pen.svg": 45268,
	"./people.svg": 38838,
	"./pig.svg": 38659,
	"./pin.svg": 41080,
	"./plus-filled.svg": 44916,
	"./plus.svg": 81445,
	"./question-3.svg": 31953,
	"./question.svg": 38229,
	"./refrash.svg": 23740,
	"./restore.svg": 33329,
	"./retry.svg": 45577,
	"./rotate-right.svg": 49989,
	"./rotate.svg": 55202,
	"./search.svg": 265,
	"./select.svg": 90925,
	"./send.svg": 44723,
	"./sephora-logo.svg": 51801,
	"./settings.svg": 71100,
	"./share.svg": 47788,
	"./shareto.svg": 37761,
	"./sort.svg": 11873,
	"./square-question.svg": 50105,
	"./star-filled.svg": 70264,
	"./star.svg": 65201,
	"./store.svg": 89078,
	"./storefront-fill.svg": 84421,
	"./tiktok-pure.svg": 15080,
	"./tip.svg": 2130,
	"./todo.svg": 54797,
	"./verified.svg": 79813,
	"./warning.svg": 9059,
	"./yes.svg": 88276,
	"./youTube.svg": 84150
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36933;